import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { AppConfigService, loadAppConfig } from './app/core/config/app-config.service';

loadAppConfig().then((config) => {
	if (config.production) {
		enableProdMode();
	}

	bootstrapApplication(AppComponent, createAppConfig()).catch((err) => console.error(err));
});

export function getOrderBackendUrl(): string {
	return new AppConfigService().config.backendOrderUrl;
}
export function getEmailBackendUrl(): string {
	return new AppConfigService().config.backendEmailUrl;
}
export function getStoreBackendUrl(): string {
	return new AppConfigService().config.backendStoreUrl;
}
export function getApiUrl(): string {
	return new AppConfigService().config.apiUrl;
}
export function getBackendAuthUrl(): string {
	return new AppConfigService().config.backendAuthUrl;
}
export function getDownloadFileUrl(): string {
	return new AppConfigService().config.downloadUrl;
}
export function getFileManagerUrl(): string {
	return new AppConfigService().config.backendFileManagerUrl;
}
export function getConfiguratorUrl(): string {
	return new AppConfigService().config.backendConfiguratorUrl;
}
export function getDeliveryUrl(): string {
	return new AppConfigService().config.backendDeliveryUrl;
}
